module.exports = __webpack_public_path__ + "static/media/a3.556391e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caoxi/a3.mp3
// module id = z4EG
// module chunks = 0